import dayjs from 'dayjs';
import { makeVar } from '@apollo/client';

type TaskItemStatusMap = Record<
  string,
  Record<string, { checked: boolean; savedAt: Date }>
>;

const TASK_ITEM_CHECK_STATUS = 'TASK_ITEM_STATUS';
const TASK_ITEM_CHECK_STATUS_SELF_LIFE = 365;

const initialTaskItemStatusMapVar =
  JSON.parse(window.localStorage.getItem(TASK_ITEM_CHECK_STATUS) ?? '{}') || {};

export const taskItemStatusMapVar = makeVar<TaskItemStatusMap>(
  initialTaskItemStatusMapVar
);

export const updateTaskItemStatus = ({
  userId,
  taskItemId,
  checked,
}: {
  userId: string;
  taskItemId: string;
  checked: boolean;
}) => {
  const current = taskItemStatusMapVar();
  const updated = {
    ...current,
    [userId]: {
      ...current[userId],
      [taskItemId]: {
        savedAt: new Date(),
        checked,
      },
    },
  };

  const updateDataInStorage = (
    newData: TaskItemStatusMap,
    selfLife = TASK_ITEM_CHECK_STATUS_SELF_LIFE
  ) => {
    try {
      window.localStorage.setItem(
        TASK_ITEM_CHECK_STATUS,
        JSON.stringify(newData)
      );
    } catch (error) {
      if (
        error instanceof DOMException &&
        error.name === 'QuotaExceededError'
      ) {
        const removeOldData = (data: TaskItemStatusMap, selfLife: number) => {
          for (const [userId, taskItemStatus] of Object.entries(data)) {
            for (const [taskItemId, status] of Object.entries(taskItemStatus)) {
              if (dayjs().diff(status.savedAt, 'd') > selfLife) {
                delete data[userId][taskItemId];
                if (!Object.keys(taskItemStatus).length) {
                  delete data[userId];
                }
              }
            }
          }

          return data;
        };

        if (selfLife !== 0) {
          updateDataInStorage(
            removeOldData(newData, selfLife),
            Math.floor(selfLife / 2)
          );
        }
      }
    }
    return newData;
  };

  taskItemStatusMapVar(updateDataInStorage(updated));
};
